// service_id local
export let SERVICE_ID = "01924e46-5aae-7989-a12b-2cbcf1c05c5c"
export let AUTH = "https://auth.tdanix.ru"
export let REQUEST = 'https://storereports.tdanix.ru'
export let PLANNOGRAMM = 'https://planogram.tdanix.ru'
export let MEDIA = 'https://media.tdanix.ru'

// ПУТИ ВЫРАЖЕННЫЕ ЧЕРЕЗ КОНСТАНТЫ
export const SEARCH_CONTAINER = "/main";
export const HINT_BLOCK = "/HintBlock";
export const HINT_CARD = "/HintCard/:id";
export const HINT_CONTAINER = "/HintContainer/:id";
export const HINT_SERIES = "/HintSeries/:id";
export const DETECTED_AUTH = "/";
export const AUTH_PAGE = "/Auth";
export const PLANNOGRAMM_LIST = "/PlannogrammList";
export const PLANNOGRAMM_ADDTASCK = "/PlannogrammAddTask";
export const PLANNOGRAMM_TASK = "/PlannogrammTask/:id";
export const BAKERY_PRODUCTS = "/BakeryProducts";
export const PRODUCT_OFFERS = "/ProductOffers";
export const CLAIMS = "/Claims";
export const ORDERS = "/Orders";
export const ORDERS_LIST = "/Orders/:id";
export const ORDERS_DETAILS = "/OrdersDetails/:id";
///

// ========== РОЛИ ПОЛЬЗОВАТЕЛЕЙ ==========
export const ROLES = {
    ORDINARY: { id: 1, name: "Обычный" },
    KUSTOVOY: { id: 2, name: "Кустовой" },
    ADMIN: { id: 3, name: "Админ" },
    UM: { id: 4, name: "УМ" },
    PLANOGRAMMER: { id: 5, name: "Планограмщик" },
    ORDINARY_PLANOGRAMMER: { id: 6, name: "Обычный Планограмщик" },
    DIRECTOR: { id: 7, name: "Руководитель" },
    TRAINING_CENTER: { id: 8, name: "Учебный центр" },
    TECHNOLOGIST: { id: 9, name: "Технолог ГВ" },
    MAIN_TECHNOLOGIST: { id: 10, name: "Главный технолог ГВ" },
    BAKER: { id: 11, name: "Пекарь" }
};

// ========== КОНФИГУРАЦИЯ МАРШРУТОВ ==========
// Для каждого маршрута указываем, какие роли его видят

export const ROUTE_CONFIG = {
    [SEARCH_CONTAINER]: {
        name: "Главная",
        path: SEARCH_CONTAINER,
        allowedRoles: [
            ROLES.ORDINARY.name,
            ROLES.KUSTOVOY.name,
            ROLES.ADMIN.name,
            ROLES.UM.name,
            ROLES.DIRECTOR.name,
            ROLES.TRAINING_CENTER.name,
            ROLES.BAKER.name,
        ],
        // Исключения: если у пользователя есть эти роли, он НЕ видит маршрут
        excludedRoles: [
            ROLES.PLANOGRAMMER.name,
            ROLES.ORDINARY_PLANOGRAMMER.name,
            ROLES.TECHNOLOGIST.name,
            ROLES.MAIN_TECHNOLOGIST.name
        ]
    },
    [HINT_BLOCK]: {
        name: "Подсказки",
        path: HINT_BLOCK,
        allowedRoles: [
            ROLES.ORDINARY.name,
            ROLES.KUSTOVOY.name,
            ROLES.ADMIN.name,
            ROLES.UM.name,
            ROLES.DIRECTOR.name,
            ROLES.TRAINING_CENTER.name,
            ROLES.BAKER.name,
        ],
        excludedRoles: [
            ROLES.PLANOGRAMMER.name,
            ROLES.ORDINARY_PLANOGRAMMER.name,
            ROLES.TECHNOLOGIST.name,
            ROLES.MAIN_TECHNOLOGIST.name
        ]
    },
    [PLANNOGRAMM_LIST]: {
        name: "Планограммы",
        path: PLANNOGRAMM_LIST,
        allowedRoles: [
            ROLES.PLANOGRAMMER.name,
            ROLES.ORDINARY_PLANOGRAMMER.name,
            ROLES.TECHNOLOGIST.name,
            ROLES.MAIN_TECHNOLOGIST.name,
            ROLES.ORDINARY.name,
            ROLES.KUSTOVOY.name,
            ROLES.ADMIN.name,
            ROLES.UM.name,
            ROLES.DIRECTOR.name,
            ROLES.TRAINING_CENTER.name,
            ROLES.BAKER.name,
        ],
        excludedRoles: []
    },
    [PRODUCT_OFFERS]: {
        name: "Ввод новинок",
        path: PRODUCT_OFFERS,
        allowedRoles: [
            ROLES.KUSTOVOY.name,
            ROLES.ADMIN.name,
            ROLES.UM.name,
        ],
        excludedRoles: [
            ROLES.ORDINARY.name,
            ROLES.PLANOGRAMMER.name,
            ROLES.ORDINARY_PLANOGRAMMER.name,
            ROLES.DIRECTOR.name,
            ROLES.TRAINING_CENTER.name,
            ROLES.TECHNOLOGIST.name,
            ROLES.MAIN_TECHNOLOGIST.name,
            ROLES.BAKER.name,
        ]
    },
    [CLAIMS]: {
        name: "Претензии",
        path: CLAIMS,
        allowedRoles: [
            ROLES.KUSTOVOY.name,
            ROLES.ADMIN.name,
            ROLES.UM.name,
            ROLES.ORDINARY.name,
            ROLES.TRAINING_CENTER.name,
            ROLES.DIRECTOR.name,
        ],
        excludedRoles: [
            ROLES.PLANOGRAMMER.name,
            ROLES.ORDINARY_PLANOGRAMMER.name,
            ROLES.TECHNOLOGIST.name,
            ROLES.MAIN_TECHNOLOGIST.name,
            ROLES.BAKER.name,
        ]
    },
    [ORDERS]:{
        name: "Заказы",
        path: ORDERS,
        allowedRoles: [
            ROLES.ADMIN.name,
        ],
        excludedRoles: [
            ROLES.PLANOGRAMMER.name,
            ROLES.ORDINARY_PLANOGRAMMER.name,
            ROLES.TECHNOLOGIST.name,
            ROLES.MAIN_TECHNOLOGIST.name,
            ROLES.BAKER.name,

            /*Это временно что бы скрыть от глаз других*/
            ROLES.KUSTOVOY.name,
            ROLES.UM.name,
            ROLES.ORDINARY.name,
            ROLES.TRAINING_CENTER.name,
            ROLES.DIRECTOR.name,
        ]
    },
    [BAKERY_PRODUCTS]: {
        name: "Производство",
        path: BAKERY_PRODUCTS,
        allowedRoles: [
            ROLES.ADMIN.name,
        ],
        excludedRoles: [
            ROLES.BAKER.name,
            ROLES.ORDINARY.name,
            ROLES.PLANOGRAMMER.name,
            ROLES.ORDINARY_PLANOGRAMMER.name,
            ROLES.TECHNOLOGIST.name,
            ROLES.MAIN_TECHNOLOGIST.name,
            ROLES.KUSTOVOY.name,
            ROLES.UM.name,
            ROLES.DIRECTOR.name,
            ROLES.TRAINING_CENTER.name,
        ]
    }
/*    [BAKERY_PRODUCTS]: {
        name: "Производство",
        path: BAKERY_PRODUCTS,
        allowedRoles: [
            ROLES.BAKER.name,
            ROLES.ADMIN.name,
            ROLES.KUSTOVOY.name,
            ROLES.UM.name,
            ROLES.DIRECTOR.name,
            ROLES.TRAINING_CENTER.name,
        ],
        excludedRoles: [
            ROLES.ORDINARY.name,
            ROLES.PLANOGRAMMER.name,
            ROLES.ORDINARY_PLANOGRAMMER.name,
            ROLES.TECHNOLOGIST.name,
            ROLES.MAIN_TECHNOLOGIST.name
        ]
    }*/
};

// ========== ВСПОМОГАТЕЛЬНЫЕ ФУНКЦИИ ==========

// Проверка, имеет ли пользователь доступ к маршруту
export const hasAccessToRoute = (routePath, userRoles, mainRole) => {
    const config = ROUTE_CONFIG[routePath];
    if (!config) {
        return true;
    }

    // Получаем названия ролей пользователя
    const userRoleNames = userRoles.map(role => role.name);

    // Добавляем основную роль, если её нет в массиве
    if (mainRole && !userRoleNames.includes(mainRole)) {
        userRoleNames.push(mainRole);
    }

    // Проверяем разрешенные роли (если есть разрешенная роль - даем доступ)
    if (config.allowedRoles && config.allowedRoles.length > 0) {
        const hasAllowedRole = config.allowedRoles.some(role => userRoleNames.includes(role));
        if (hasAllowedRole) {
            return true;
        }
    }

    // Проверяем исключения (только если нет разрешенных ролей)
    if (config.excludedRoles && config.excludedRoles.length > 0) {
        const hasExcludedRole = config.excludedRoles.some(role => userRoleNames.includes(role));
        if (hasExcludedRole) {
            return false;
        }
    }

    return true;
};

// Получение списка доступных маршрутов для пользователя
export const getAvailableRoutes = (userRoles) => {
    // Если нет ролей - возвращаем пустой массив
    if (!userRoles || userRoles.length === 0) {
        return [];
    }

    // Получаем имена ролей пользователя
    const userRoleNames = userRoles.map(role => role.name);

    // Проходим по всем маршрутам и проверяем доступ
    const availableRoutes = [];

    for (const [path, config] of Object.entries(ROUTE_CONFIG)) {
        // Проверяем, есть ли у пользователя роль из allowedRoles
        const hasAllowedRole = config.allowedRoles.some(role => userRoleNames.includes(role));

        // Проверяем, нет ли у пользователя роли из excludedRoles
        const hasExcludedRole = config.excludedRoles.some(role => userRoleNames.includes(role));

        // Маршрут доступен, если есть allowedRole и нет excludedRole
        if (hasAllowedRole && !hasExcludedRole) {
            availableRoutes.push({
                name: config.name,
                path: path
            });
        }
    }

    return availableRoutes;
};

///
// user login
export function USER_LOGIN () {
    return(localStorage.getItem("USER_LOGIN"))
}

// айдишник куста local
export let SELECTED_KYST_ID = Number(localStorage.getItem('SELECTED_KYST_ID')); // 0

export function UPDATE_SELECTED_KYST_ID(selectedKyst) {
    SELECTED_KYST_ID = Number(selectedKyst);
    localStorage.setItem('SELECTED_KYST_ID', SELECTED_KYST_ID);
    return SELECTED_KYST_ID;
}

export function GET_SELECTED_KYST_ID() {
    return SELECTED_KYST_ID;
}

// айдишник магазина local
export let SELECTED_SHOP_ID = Number(localStorage.getItem('SELECTED_SHOP_ID')); // 0

export function UPDATE_SELECTED_SHOP_ID(selectedShop) {
    SELECTED_SHOP_ID = Number(selectedShop);
    localStorage.setItem('SELECTED_SHOP_ID', SELECTED_SHOP_ID);
    return SELECTED_SHOP_ID;
}

export function GET_SELECTED_SHOP_ID() {
    return SELECTED_SHOP_ID;
}

// айдишник категории local
export let SELECTED_GROUP_ID = Number(localStorage.getItem('SELECTED_GROUP_ID')); // 0

export function UPDATE_SELECTED_GROUP_ID(category) {
    SELECTED_GROUP_ID = Number(category);
    localStorage.setItem('SELECTED_GROUP_ID', SELECTED_GROUP_ID);
    return SELECTED_GROUP_ID;
}

export function GET_SELECTED_GROUP_ID() {
    return SELECTED_GROUP_ID;
}


// refresh_token local
export let REFRESH_TOKEN = localStorage.getItem('REFRESH_TOKEN'); // 0

export function UPDATE_REFRESH_TOKEN(refreshToken) {
    REFRESH_TOKEN = refreshToken;
    localStorage.setItem('REFRESH_TOKEN', REFRESH_TOKEN);
    return REFRESH_TOKEN;
}

export function GET_REFRESH_TOKEN() {
    return REFRESH_TOKEN;
}

// AttachUser local
export let ATTACH_USER_ID = localStorage.getItem('ATTACH_USER_ID'); // 0

export function UPDATE_ATTACH_USER_ID(selectedAttachUser) {
    ATTACH_USER_ID = selectedAttachUser;
    localStorage.setItem('ATTACH_USER_ID', ATTACH_USER_ID);
    return ATTACH_USER_ID;
}

export function GET_ATTACH_USER_ID() {
    return ATTACH_USER_ID;
}

// Название куста
export let SELECTED_CUST_NAME = Number(localStorage.getItem('SELECTED_CUST_NAME')); // 0

export function UPDATE_SELECTED_CUST_NAME(selectedCustName) {
    SELECTED_CUST_NAME = selectedCustName;
    localStorage.setItem('SELECTED_CUST_NAME', SELECTED_CUST_NAME);
    return SELECTED_CUST_NAME;
}

export function GET_SELECTED_CUST_NAME() {
    try {
        const value = localStorage.getItem("SELECTED_CUST_NAME");
        return typeof value === 'string' ? value : "";
    } catch (error) {
        console.error("Error reading SELECTED_CUST_NAME:", error);
        return "";
    }
}

// Название магазина
export let SELECTED_SHOP_NAME = Number(localStorage.getItem('SELECTED_SHOP_NAME')); // 0

export function UPDATE_SELECTED_SHOP_NAME(selectedShopName) {
    SELECTED_SHOP_NAME = selectedShopName;
    localStorage.setItem('SELECTED_SHOP_NAME', SELECTED_SHOP_NAME);
    return SELECTED_SHOP_NAME;
}

export function GET_SELECTED_SHOP_NAME() {
    try {
        const value = localStorage.getItem("SELECTED_SHOP_NAME");
        return typeof value === 'string' ? value : "";
    } catch (error) {
        console.error("Error reading SELECTED_SHOP_NAME:", error);
        return "";
    }
}

// Название категории
export let SELECTED_CATEGORY_NAME = Number(localStorage.getItem('SELECTED_CATEGORY_NAME')); // 0

export function UPDATE_CATEGORY_NAME(selectedCategoryName) {
    SELECTED_CATEGORY_NAME = selectedCategoryName;
    localStorage.setItem('SELECTED_CATEGORY_NAME', SELECTED_CATEGORY_NAME);
    return SELECTED_CATEGORY_NAME;
}

export function GET_CATEGORY_NAME() {
    try {
        const value = localStorage.getItem("SELECTED_CATEGORY_NAME");
        return typeof value === 'string' ? value : "";
    } catch (error) {
        console.error("Error reading SELECTED_CATEGORY_NAME:", error);
        return "";
    }
}

// access_token cooke
//создание куки
export function SET_COOKIE(name, value, maxAge) {
    document.cookie = `${name}=${value};max-age=${maxAge};path=/;SameSite=Strict;`;
}

export function GET_ROLE (){
    return (localStorage.getItem("ROLE"))
}

// функция удаления из локел сторедж
export function DELETE_DATA_IN_LocalStorage(key) {
    localStorage.removeItem(key);
}

